import axios from "axios";

const ENDPOINTS = {
  USER_PROFILE: "/assets/v2/Me",
  AUTH: "/auth/",
};

export default class Starfleet {
  constructor(apiUrl, configs) {
    this.API_URL = apiUrl;
    this.configs = configs;
  }

  clearStorage() {
    localStorage.removeItem(this.configs.SESSION_ITEM_NAME);
    localStorage.removeItem(this.configs.LAST_LOGIN);
    localStorage.removeItem(this.configs.PRIVACY_ITEM_NAME);
    localStorage.removeItem(this.configs.LOGIN_HINTS_ITEM_NAME);
  }

  authorize(ui_locales, prompt = "select_account") {
    this.clearStorage();
    const [lang, region] = ui_locales.split("-");
    const searchParams = new URLSearchParams({
      redirect_uri: location.href,
      client_id: this.configs.CLIENT_ID,
      idp_id: JARVIS_IDP_ID,
      ui_locales: `${lang}-${region.toUpperCase()}`,
      prompt,
    });
    const redirectUrl = `${AUTH_URL}?${searchParams.toString()}`;
    window.location.href = redirectUrl;
    return false;
  }

  getLocalSession(resolve) {
    const session = JSON.parse(
      localStorage.getItem(this.configs.SESSION_ITEM_NAME)
    );
    if (session && new Date(session.expiration) > new Date()) {
      resolve(session);
      return true;
    } else return false;
  }

  getSsoSession(resolve) {
    const ssoSession = JSON.parse(
      localStorage.getItem(localStorage.getItem(this.configs.LAST_LOGIN))
    );

    if (
      ssoSession &&
      this.configs.SUPPORTED_IDPS.includes(ssoSession.idp_id) &&
      new Date(ssoSession.expiration) > new Date()
    ) {
      resolve(ssoSession);
      return true;
    } else return false;
  }

  /**
   * @name getSession
   * @description Function that fetches the user session info based on SSO logic
   * @param {string} ui_locales
   *
   * @returns {Promise} session data
   */
  async getSession(ui_locales) {
    return new Promise((resolve) => {
      (async () => {
        if (this.getLocalSession(resolve)) {
          return;
        } else if (this.getSsoSession(resolve)) {
          return;
        }
        resolve(false);
      })();
    });
  }

  getProfile(accessToken) {
    return axios.get(`${this.API_URL}${ENDPOINTS.USER_PROFILE}`, {
      params: {},
      headers: { Authorization: `Bearer ${accessToken}` },
    });
  }
}
